/**
 * Gift card balance form.
 *
 * Calls scripts/revel-giftcard-balance.php (deployed separately, outside
 * this theme) over CORS. That endpoint wraps the Revel API lookup - GET
 * /resources/GiftCard/?number={number}, reads remaining_balance - and
 * responds with JSON:
 *   { "found": true, "balance": 12.34 }
 *   { "found": false }
 *   { "error": "..." }
 *
 * This is a temporary test wiring, hosted outside Shopify. For production
 * this should move behind a Shopify App Proxy so it's same-origin and not
 * dependent on a personal domain staying up.
 */

(function () {
  var GIFT_CARD_BALANCE_ENDPOINT = 'https://andreiserban.com/cl/scripts/revel-giftcard-balance.php';

  function formatBalance(balance, currency) {
    var amount = Number(balance);
    if (isNaN(amount)) {
      return balance;
    }
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2);
    }
  }

  function setResult(resultEl, text, state) {
    resultEl.textContent = text;
    resultEl.classList.remove('is-success', 'is-error', 'is-loading');
    if (state) {
      resultEl.classList.add(state);
    }
  }

  function handleSubmit(event) {
    var form = event.currentTarget;
    event.preventDefault();

    var resultEl = form.querySelector('[data-gift-card-balance-result]');
    var numberInput = form.querySelector('input[name="number"]');

    if (!resultEl || !numberInput) {
      return;
    }

    var number = numberInput.value.trim();
    if (!number) {
      return;
    }

    var messageLookingUp = form.getAttribute('data-message-looking-up');
    var messageFound = form.getAttribute('data-message-found');
    var messageNotFound = form.getAttribute('data-message-not-found');
    var messageError = form.getAttribute('data-message-error');
    var currency = form.getAttribute('data-currency');

    setResult(resultEl, messageLookingUp, 'is-loading');

    var url = GIFT_CARD_BALANCE_ENDPOINT + '?number=' + encodeURIComponent(number);

    fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Request failed with status ' + response.status);
        }
        return response.json();
      })
      .then(function (data) {
        if (data && data.found) {
          var formatted = formatBalance(data.balance, currency);
          setResult(resultEl, messageFound.replace('[balance]', formatted), 'is-success');
        } else {
          setResult(resultEl, messageNotFound, 'is-error');
        }
      })
      .catch(function () {
        setResult(resultEl, messageError, 'is-error');
      });
  }

  function bindForms(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('[data-gift-card-balance-form]');
    forms.forEach(function (form) {
      if (form.dataset.giftCardBalanceBound) {
        return;
      }
      form.dataset.giftCardBalanceBound = 'true';
      form.addEventListener('submit', handleSubmit);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindForms(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    bindForms(event.target);
  });
})();
